import { render, staticRenderFns } from "./TheMask.vue?vue&type=template&id=376c5c1a&"
import script from "./TheMask.vue?vue&type=script&lang=js&"
export * from "./TheMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports